import React, { Fragment } from 'react';
import { Field } from 'formik';
import { FovFieldError, FovSelect, VerticalSpacer } from 'components';
import _ from 'lodash';

const CategorySelect = ({ form, categories, rpcCategories }) => {
  return (
    <Fragment>
      Category*
      <VerticalSpacer size={10} />

      <Field type='select' name='categoryName'>
        {data => (
          <FovSelect
            value={data.field.value}
            placeholder={data.field.value}
            disabled={_.isEmpty(rpcCategories)}
            onChange={(e, newVal) => {
              form.setFieldValue(data.field.name, newVal);
            }}
          >
            {categories}
          </FovSelect>
        )}
      </Field>

      <FovFieldError name='categoryName' />
    </Fragment>
  );
};

export default CategorySelect;

